// Servicio para obtener datos de tratamientos para mostrar en PartnersList
import tratamientoService from './tratamientoService';

const partnerTratamientoService = {
    // Obtener resumen de tratamientos para mostrar en información de socia
    async getTratamientosResumen(pacienteId) {
        try {
            const result = await tratamientoService.getTratamientosBySocia(pacienteId);
            
            console.log('📋 Tratamientos recibidos del backend:', result.data);
            
            if (result.success && result.data) {
                // Procesar datos para mostrar solo información relevante
                const tratamientos = result.data.map(tratamiento => {
                    console.log('🔍 Procesando tratamiento:', tratamiento);
                    // Obtener medicamentos
                    const medicamentos = tratamiento.MEDICAMENTOS || tratamiento.medicamentos || [];
                    console.log('💊 Medicamentos encontrados:', medicamentos);
                    
                    // Crear texto con todos los medicamentos
                    let textoMedicamentos = 'Sin medicamento';
                    if (medicamentos.length > 0) {
                        if (medicamentos.length === 1) {
                            const med = medicamentos[0];
                            textoMedicamentos = `${med.MEDICAMENTO_NOMBRE || med.medicamento_nombre} (${med.MEDICAMENTO_CANTIDAD || med.medicamento_cantidad} ${med.MEDICAMENTO_UNIDAD || med.medicamento_unidad || ''})`;
                        } else {
                            // Si hay múltiples medicamentos, mostrar el primero y cuántos más hay
                            const primerMed = medicamentos[0];
                            textoMedicamentos = `${primerMed.MEDICAMENTO_NOMBRE || primerMed.medicamento_nombre} (${primerMed.MEDICAMENTO_CANTIDAD || primerMed.medicamento_cantidad} ${primerMed.MEDICAMENTO_UNIDAD || primerMed.medicamento_unidad || ''}) +${medicamentos.length - 1} más`;
                        }
                    }
                    
                    // Construir nombre completo del médico
                    const nombreMedico = (tratamiento.MEDICO_NOMBRE || tratamiento.medico_nombre) && (tratamiento.MEDICO_APELLIDO || tratamiento.medico_apellido)
                        ? `${tratamiento.MEDICO_NOMBRE || tratamiento.medico_nombre} ${tratamiento.MEDICO_APELLIDO || tratamiento.medico_apellido}`
                        : (tratamiento.MEDICO_NOMBRE || tratamiento.medico_nombre) || 'Médico no especificado';

                    return {
                        id: tratamiento.TRATAMIENTO_ID || tratamiento.tratamiento_id,
                        medicamento: textoMedicamentos,
                        medicamentos: medicamentos,
                        medicoId: tratamiento.MEDICO_ID || tratamiento.medico_id,
                        medico: nombreMedico,
                        especialidad: tratamiento.MEDICO_ESPECIALIDAD || tratamiento.medico_especialidad || 'Especialidad no especificada',
                        fechaInicio: tratamiento.TRATAMIENTO_FECHAINICIO || tratamiento.tratamiento_fechainicio,
                        fechaFin: tratamiento.TRATAMIENTO_FECHAFIN || tratamiento.tratamiento_fechafin,
                        estado: partnerTratamientoService.calcularEstadoTratamiento(tratamiento),
                        descripcion: tratamiento.TRATAMIENTO_OBSERVACION || tratamiento.tratamiento_observacion || ''
                    };
                });

                return {
                    success: true,
                    data: tratamientos,
                    count: tratamientos.length
                };
            }

            return {
                success: true,
                data: [],
                count: 0
            };
        } catch (error) {
            console.error('Error al obtener tratamientos:', error);
            return {
                success: false,
                data: [],
                count: 0,
                error: error.message
            };
        }
    },

    // Calcular estado del tratamiento basado en fechas
    calcularEstadoTratamiento(tratamiento) {
        const hoy = new Date();
        const fechaInicio = new Date(tratamiento.TRATAMIENTO_FECHAINICIO || tratamiento.tratamiento_fechainicio);
        const fechaFin = new Date(tratamiento.TRATAMIENTO_FECHAFIN || tratamiento.tratamiento_fechafin);
        
        if (hoy < fechaInicio) {
            return 'Programado';
        } else if (hoy >= fechaInicio && hoy <= fechaFin) {
            return 'En Curso';
        } else {
            return 'Finalizado';
        }
    },

    // Formatear fecha para mostrar
    formatearFecha(fechaString) {
        if (!fechaString) return 'No definida';
        const fecha = new Date(fechaString);
        return fecha.toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    }
};

export default partnerTratamientoService;